/**
 * フォーム関係-外部DBの値を表示するコンポーネント
 * メモ：JSONのformTypeに応じて整形している
 */
import React, { useEffect, useMemo, useState } from "react";

import { TFormColumn, TExternalDBData } from "../../../common/components/types";

import formStore from "../../../../store/formStore";
import { jsonParseSafety } from "../../../../utils/formData";
import { separateWithComma } from "../../../../utils/string";

import ShowFile from "../../../common/components/atoms/ShowFile";

type Props = {
  columnName: TFormColumn;
  terminalGridId: number | undefined;
  gridId: number | undefined;
  dbName: keyof TExternalDBData;
};

const ShowExternalDBValue: React.FC<Props> = (props: Props) => {
  const { columnName, terminalGridId, gridId, dbName } = props;

  const [row, setRow] = useState(
    formStore.getFormRow(columnName, terminalGridId, gridId)
  );

  const value = useMemo(() => {
    switch (dbName) {
      case "jtbApproved":
        return row?.jtbApproved;
      case "centerReflected":
        return row?.centerReflected;
      case "centerToBeReflected":
        return row?.centerToBeReflected;
      default:
        return undefined;
    }
  }, [row, dbName]);

  useEffect(() => {
    const fn = () => {
      const r = formStore.getFormRow(columnName, terminalGridId, gridId);
      setRow(r && { ...r });
    };
    formStore.addListener(columnName, fn);

    return () => formStore.removeListener(columnName, fn);
  }, [columnName, terminalGridId, gridId]);

  if (!row) return null;

  return value ? (
    <>
      {(row.json.formType === "text" || row.json.formType === "date") && value}
      {row.json.formType === "number" && separateWithComma(value)}
      {(row.json.formType === "radio" ||
        row.json.formType === "select" ||
        row.json.formType === "search-select" ||
        // TODO: 今回 checkbox は対応見送りになっている。使う場合は調整が必要
        row.json.formType === "checkbox") &&
      value !== ""
        ? Object.values(jsonParseSafety(value))[0]
        : ""}
      {row.json.formType === "textArea" && (
        <>
          {value.split("\n").map((line: string) => (
            <span key={line}>
              {line}
              <br />
            </span>
          ))}
        </>
      )}
      {row.json.formType === "file" && (
        <ShowFile formGroupName={row.json.formGroupName} formContent={value} />
      )}
    </>
  ) : null;
};

export default ShowExternalDBValue;
